/**
 * This plugin adds browser / device detection for different devices and browsers and writes classes to the html tag
 *
 * Usage in TS:
 *
 * import { browserDeviceTests } from '@swisslife/shared-ui/src/utils/browser-detection/js/browser-detection';
 * console.log(browserDeviceTests.ie);
 */

function testForEdge() {
	const ua = window.navigator.userAgent;
	const edge = ua.indexOf('Edge');

	return edge > 0;
}

function testForIE() {
	const ua = window.navigator.userAgent;
	const msie = ua.indexOf('MSIE ');

	return msie > 0 || Boolean(navigator.userAgent.match(/Trident.*rv:11\./));
}

function testForIos() {
	return Boolean(navigator.userAgent.match(/iPad|iPhone|iPod/g));
}

function testForIpad() {
	return Boolean(navigator.userAgent.match(/(iPad)/g));
}

function testForAndroid() {
	return Boolean(navigator.userAgent.match(/Android/g));
}

export const browserDeviceTests = {
	edge: testForEdge(),
	ie: testForIE(),
	ios: testForIos(),
	ipad: testForIpad(),
	android: testForAndroid(),
};

const htmlTag = document.documentElement as any;

for (const testName in browserDeviceTests) {
	if (browserDeviceTests.hasOwnProperty(testName)) {
		if (browserDeviceTests[testName]) {
			htmlTag.className += ` h-browser-device--${testName}`;
		}
	}
}
